<template>
  <div ref="wrapper"
       class="zoom-slider-wrapper"
  />
</template>

<script>
  import ZoomSliderControl from './zoom-slider-control';

  export default {
    name: 'ZoomSliderWrapper',
    inject: ['viewport', 'dependencies'],
    mounted () {
      return new ZoomSliderControl(this.viewport, this.$refs.wrapper, this.dependencies);
    }
  };
</script>

<style scoped lang="scss">
.zoom-slider-wrapper {
  min-height: 100px;
}
</style>
